import React from 'react';

import { FiUsers } from 'react-icons/fi';
import { Link } from 'react-router-dom';

const NoUsersRecords = () => {
  return (
    <div className="container text-center mt-5">
      <div>
        <FiUsers size={100} color="#ccc" />
      </div>
      <p className="mt-3">
        Nenhum membro adicionado ao seu time ainda. <Link to="/admin/members/invite/new">Clique aqui</Link> para adicionar o primeiro!
      </p>
    </div>
  );
};

export default NoUsersRecords;
